import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskFieldsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-fields',
	path: '/jira/servicedesk/projects/:projectKey/settings/fields',
	exact: true,
};
